export default __webpack_public_path__ + "static/media/robot.8d92f47b.png";